import type { SimplifiedBusLayout } from "./seat-selection-gender-rules";

import { SeatSelectionGenderRules } from "./seat-selection-gender-rules";
import { SeatSelectionNoRules } from "./seat-selection-no-rules";

function hasGenderRules(bus: SimplifiedBusLayout): boolean {
  const { rules } = bus;

  return !!(
    rules &&
    rules.max_number_of_gendered_seat &&
    (rules.max_number_of_gendered_seat.female ||
      rules.max_number_of_gendered_seat.male)
  );
}

export function createSeatSelectionValidator(
  bus?: SimplifiedBusLayout | null
): SeatSelectionNoRules | SeatSelectionGenderRules {
  if (bus && hasGenderRules(bus)) {
    return new SeatSelectionGenderRules(bus);
  } else {
    return new SeatSelectionNoRules();
  }
}
